var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browser-not-supported"},[_vm._v(" Sorry, your browser is not supported. Please use the latest version of "),_c('a',{attrs:{"href":"https://www.google.com/chrome/"}},[_vm._v("Chrome")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://www.apple.com/safari/"}},[_vm._v("Safari")]),_vm._v(" for the best experience. ")])
}]

export { render, staticRenderFns }